const CaretRightIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10" fill="none">
            <path d="M0.999996 0.466716C0.866663 0.466716 0.733329 0.466715 0.666663 0.600048C0.466663 0.800049 0.466663 1.13338 0.666663 1.33338L4.33333 5.00005L0.666663 8.66672C0.466663 8.86672 0.466663 9.20005 0.666663 9.40005C0.866663 9.60005 1.2 9.60005 1.4 9.40005L5.4 5.40005C5.6 5.20005 5.6 4.86672 5.4 4.66672L1.4 0.666716C1.33333 0.600049 1.2 0.533381 1.06666 0.533381L0.999996 0.466716Z" fill="currentColor"/>
        </svg>
    )
}

export default CaretRightIcon;